module.exports = __webpack_public_path__ + "static/media/Slide10.4f15f711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide10.png
// module id = 1632
// module chunks = 0